import { Flex, Pagination } from 'antd';
import { cn } from '../lib/cn';

interface CustomPaginationProps {
  limit: number;
  total: number;
  page?: number;
  hidePagination?: boolean;
  hidePage?: boolean;
  className?: string;
  handlePagination?: (paginationPage: number, paginationLimit: number) => void;
}

export default function CustomPagination({
  limit,
  total,
  page,
  hidePagination,
  hidePage,
  className = '',
  handlePagination,
}: CustomPaginationProps) {
  const safePage = page || 1; // ensure page starts at 1
  const start = (safePage - 1) * limit + 1;
  const end = Math.min(safePage * limit, total);

  if (!hidePagination && total && limit)
    return (
      <Flex
        gap={8}
        wrap={true}
        align="center"
        justify={hidePage ? 'center' : 'space-between'}
        className={cn('custom-pagination px-4 py-2.5 mt-2', className)}
      >
        {!hidePage && (
          <Flex
            align="center"
            gap={8}
            className="text-sm text-white tracking-wide"
          >
            Showing {start} to {end} of {total} entries
          </Flex>
        )}

        {/* Ant Design Pagination */}
        <Pagination
          total={total}
          current={page}
          pageSize={limit}
          showSizeChanger={false}
          onChange={handlePagination}
          itemRender={(_, type, __) => {
            if (type === 'prev') return <span>Previous</span>;
            if (type === 'next') return <span>Next</span>;
            return __;
          }}
        />
      </Flex>
    );

  return null;
}
